import React, { useCallback } from "react";
import { AgGridReact } from "ag-grid-react";

import TableControls from "./TableControls";

import "./agclient.css";

const AgGridClient = ({
  rowData = [],
  columnDefs = [],
  pagination = true,
  paginationPageSize = 5,
  paginationPageSizeSelector = [5, 10, 20, 50, 100],
  defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
  },
  gridOptions = {},
  onGridReady = null,
  className = "",
  selectedColumns = [],
  defaultVisibleColumns = [],
  onColumnSelectionChange = () => {},
  allColumnDefs = [],

  gridApi,

  actionButton,

  enableColumnSelection = true,
  showResetFilters = true,
  hideControls = false,
  enableCellFocus = false,

  ...otherProps
}) => {
  const defaultGridOptions = {
    pagination,
    paginationPageSize,
    paginationPageSizeSelector,
    defaultColDef,
    rowSelection: "single",
    suppressRowClickSelection: true,
    suppressCellFocus: !enableCellFocus,

    icons: {
      filter:
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>',
    },
    tooltipShowDelay: 500,
    ...gridOptions,
  };

  const resetFiltersFunction = useCallback(() => {
    if (gridApi) {
      gridApi.setFilterModel(null);
      gridApi.resetColumnState();
      gridApi.clearFocusedCell();
    }
  }, [gridApi]);

  return (
    <div
      className="client-side-datatable"
      style={{
        flex: "1 1 auto",
        width: "100%",
        minHeight: "400px",
        height: "100%",
      }}
    >
      {!hideControls && (
        <TableControls
          resetFiltersFunction={
            showResetFilters ? resetFiltersFunction : undefined
          }
          columnDefs={
            enableColumnSelection
              ? allColumnDefs.length > 0
                ? allColumnDefs
                : columnDefs
              : null
          }
          selectedColumns={selectedColumns}
          defaultVisibleColumns={defaultVisibleColumns}
          onColumnSelectionChange={onColumnSelectionChange}
          actionButton={actionButton}
        />
      )}

      <AgGridReact
        rowData={rowData}
        columnDefs={columnDefs}
        gridOptions={defaultGridOptions}
        onGridReady={onGridReady}
        suppressColumnVirtualisation={true}
        suppressDragLeaveHidesColumns={true}
        rowHeight={36}
        {...otherProps}
      />
    </div>
  );
};

export default AgGridClient;
